export default __webpack_public_path__ + "static/media/1492509293_itunes_ios7_ios_7.65587412.png";